import React from 'react'

import Editor from '~/webhooks/components/subscription_editor.jsx'

class NewSubscription extends React.Component {
  render() {
    return <Editor returnTo="/" name="Add webhook" allowSave={true} />
  }
}

export default NewSubscription
